// extracted by mini-css-extract-plugin
module.exports = {"images":"Location_images_kV1J4","header":"Location_header_2zNZo","map":"Location_map_3XITw"};